import { render } from "./school.vue?vue&type=template&id=4b3dc86e"
import script from "./school.vue?vue&type=script&lang=js"
export * from "./school.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/map-here/markers/school.vue'],['render',render],['__file',"school.vue"]])

export default __exports__